import React, { Component, useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table } from 'reactstrap';
import moment from 'moment';

const VendServerPorts = (props) => {

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        getTableData();
    }, [])

    useEffect(() => {
        getTableData();
    }, [props.servpk])

    function getTableData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: props.userData.level,
            servpk: props.servpk
        }
        fetch('GetVendServerPorts', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        localStorage.setItem("lastFetch", moment());
    }

    return (<div>
        <Table className="halfOfParent">
            <thead>
                <tr>
                    <th>Open Port</th>
                    <th>Active</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                <tr>
                        <td>{item.port}</td>
                        <td>{item.active}</td>
                </tr>
                 )) }
            </tbody>
        </Table>
    </div>)
}

export default VendServerPorts;